import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../../../../styles'
import { FormattedMessage, IntlShape, useIntl } from 'react-intl'
import selectColorEnum from '../../../../../enums/selectEnums/SelectColorEnum'
import selectSizeEnum from '../../../../../enums/selectEnums/SelectSizeEnum'
import { MenuItem } from '@material-ui/core'
import classNames from 'classnames'
import { ClassValue } from 'classnames/types'
import FormSelectField from '../../../../../components/fields/FormSelectField'
import { Field } from 'react-final-form'
import { timeSlotEnum, weekDaysEnum } from '../../../../../enums/choicesEnum'

const useStyle = makeStyles((theme) => ({
	...styles(theme),
	textNotSelected: {
		color: theme.palette.blue['50']
	},
	selectContainer: {
		padding: '15px 0px',
		alignItems: 'center'
	}
}))

interface AcceptingProps {
	labelChoice: string,
	name: string,
	errors?: any,
	isLargeScreen: boolean
}

type DateTimeSlotSelectProps = AcceptingProps

const DateTimeSlotSelect: React.FC<DateTimeSlotSelectProps> = (
	{
		labelChoice,
		name,
		errors,
		isLargeScreen
	}
) => {
	const classes = useStyle()
	const intl: IntlShape = useIntl()

	const defaultDate: string = intl.formatMessage({
		id: 'requests.makeRequest.step4.dateText',
		defaultMessage: 'Date',
		description: 'text date in select'
	})

	const defaultTimeSlot: string = intl.formatMessage({
		id: 'requests.makeRequest.step4.timeSlotText',
		defaultMessage: 'Créneau',
		description: 'text timeSlot in select'
	})

	const inputText = classNames(
		isLargeScreen ? classes.text8 : classes.text14,
		classes.colorBlue,
		classes.semiBold
	)

	const textSelect = classNames(
		classes.text8,
		classes.textNotSelected
	)

	const choiceClass: ClassValue = classNames(
		classes.semiBold,
		isLargeScreen ? [classes.text0] : [classes.title4],
		classes.colorBlue,
		isLargeScreen ? 'col-sm-4' : 'col-sm-12'
	)

	const selectContainer: ClassValue = classNames(
		classes.selectContainer,
		isLargeScreen && 'row',
		'col-xs-12'
	)

	const selectFieldContainer: ClassValue = classNames(
		isLargeScreen ? 'col-xs-8' : 'col-sm-12',
		'row'
	)

	return (
		<div className={selectContainer}>
			<span className={choiceClass}>
				{labelChoice}
		    </span>
			<div className={selectFieldContainer}>
				<div className={isLargeScreen ? 'col-sm-6' : 'col-xs-6'}>
					<Field
						initialValue={defaultDate}
						name={`${name}.weekDay`}
						component={FormSelectField}
						inputTextStyle={inputText}
						backgroundColor={selectColorEnum.grey}
						size={isLargeScreen ? selectSizeEnum.big : selectSizeEnum.small}
						errorMessage={errors ? errors.weekDay : ''}
					>
						<MenuItem
							key={defaultDate}
							value={defaultDate}
							className={textSelect}>
							{defaultDate}
						</MenuItem>
						{
							Object.values(weekDaysEnum).map((weekDay: string) =>
								<MenuItem
									key={weekDay}
									value={weekDaysEnum[weekDay as keyof typeof weekDaysEnum]}
									className={textSelect}
								>
									<FormattedMessage
										id={`requests.weekDays.${weekDaysEnum[weekDay as keyof typeof weekDaysEnum]}`}
										defaultMessage={weekDay}
										description={`${weekDay} weekDay`}
									/>
								</MenuItem>
							)
						}
					</Field>
				</div>
				<div className={isLargeScreen ? 'col-sm-6' : 'col-xs-6'}>
					<Field
						initialValue={defaultTimeSlot}
						name={`${name}.timeSlot`}
						component={FormSelectField}
						inputTextStyle={inputText}
						backgroundColor={selectColorEnum.grey}
						size={isLargeScreen ? selectSizeEnum.big : selectSizeEnum.small}
						errorMessage={errors ? errors.timeSlot : ''}
					>
						<MenuItem
							key={defaultTimeSlot}
							value={defaultTimeSlot}
							className={textSelect}
						>
							{defaultTimeSlot}
						</MenuItem>
						{
							Object.values(timeSlotEnum).map((timeSlot: string) =>
								<MenuItem
									key={timeSlot}
									value={timeSlotEnum[timeSlot as keyof typeof timeSlotEnum]}
									className={textSelect}
								>
									<FormattedMessage
										id={`requests.timeSlots.${timeSlotEnum[timeSlot as keyof typeof timeSlotEnum]}`}
										defaultMessage={timeSlot}
										description={`${timeSlot} timeSlot`}
									/>
								</MenuItem>
							)
						}
					</Field>
				</div>
			</div>
		</div>
	)
}

export default DateTimeSlotSelect